import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6311a84a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header-therapist" }
const _hoisted_2 = { class: "body_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("HEADER.THERAPIST", { name: _ctx.user.therapist.name })), 1)
  ]))
}